import {getLanguageCodes} from "../../../api/models/Translation";

class Languages {
    public static languages: any = null;

    public static list = async () => {
        if (Languages.languages) {
            return Languages.languages;
        } else {
            const langCodes = await getLanguageCodes();

            if (!langCodes) {
                return;
            }

            langCodes.sort((a: any, b: any) => {
                return a.name > b.name ? 1 : -1;
            });

            langCodes.unshift({
                name: "-",
                code: ""
            });

            Languages.languages = langCodes;

            return Languages.languages;
        }
    };
}

export default Languages;


// WEBPACK FOOTER //
// ./src/components/model/Translation/Languages.ts